import type { KeywordGroup } from '../../revenueintel/framework';

type Props = { groups?: KeywordGroup[] };

export function KeywordIntelligenceCard({ groups = [] }: Props) {
  return (
    <div className="space-y-3">
      {groups.map((g) => (
        <div key={g.category}>
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">{g.category}</p>
          <div className="mt-1 flex flex-wrap gap-1">
            {g.keywords.map((kw) => (
              <span
                key={kw}
                className="rounded border border-slate-200 px-2 py-0.5 text-xs dark:border-slate-700"
              >
                {kw}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
